import 'css-chunk:src/app/containers/Home/ApplicationsView/ApplicationListView.scss';export default {
  "ApplicationListView": "_ApplicationListView_7lmtj_2",
  "header": "_header_7lmtj_2",
  "createButton": "_createButton_7lmtj_7",
  "table": "_table_7lmtj_10",
  "nameCell": "_nameCell_7lmtj_10"
};